/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Master {

    @Serenity.Decorators.registerClass()
    export class CitiesGrid extends NoboxEntityGrid<CitiesRow, any> {
        protected getColumnsKey() { return CitiesColumns.columnsKey; }
        protected getDialogType() { return CitiesDialog; }
        protected getIdProperty() { return CitiesRow.idProperty; }
        protected getInsertPermission() { return CitiesRow.insertPermission; }
        protected getLocalTextPrefix() { return CitiesRow.localTextPrefix; }
        protected getService() { return CitiesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let country = Q.getLookup("Nobox.Countries").itemById;
            let states = Q.getLookup("Nobox.States").itemById;

            Q.first(columns, x => x.field == CitiesRow.Fields.CountryId).format =
                ctx => {
                    if (country[ctx.value] != undefined) {
                        return `<a href="javascript:;" class="country-link">${Q.htmlEncode(country[ctx.value]["Name"])}</a>`;
                    } else {
                        return "";
                    }
                };
            Q.first(columns, x => x.field == CitiesRow.Fields.StateId).format =
                ctx => {
                    if (states[ctx.value] != undefined) {
                        return `<a href="javascript:;" class="states-link">${Q.htmlEncode(states[ctx.value]["Name"])}</a>`;
                    } else {
                        return "";
                    }
                };

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("country-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by country");
                var countryFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CitiesRow.Fields.CountryId);
                countryFilter.set_value(`${item.CountryId}`);
                this.refresh();
            }else if (target.hasClass("states-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by states");
                var countryFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CitiesRow.Fields.StateId);
                countryFilter.set_value(`${item.StateId}`);
                this.refresh();
            }
        }
    }
}